package fr.manyverse.app

import kotlinx.browser.window

class JsPlatform : Platform {
    override val name: String = "Web with Kotlin/JS"
    override val isAppleSignInAvailable: Boolean = true
    override val oauthRedirectUrl: String = window.location.origin
    override val isMobile: Boolean = false
}

actual fun getPlatform(): Platform = JsPlatform()